export default "__VITE_ASSET__c4a04947__"